// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"db10a63c","626":"3cfaf594"}[chunkId] + ".chunk.css";
};